import withInputFields from "../../helpers/inputfields";
import withCountdownTimer from "../../helpers/countdowntimer";
import withReactiveFields from "../../helpers/reactivefields";
import { withProperties, getValueAtPath } from "../../../../utils";
import { selectBankFromList } from "../../../../collections/nigerianbanks";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import ErrorState from "../../../common/error";

import BankView from "./views/bank";
import CodeView from "./views/code";
import SuccessView from "../../common/success";

const METHOD = 'ussd';
const METHOD_NAME = 'USSD';
const CHARGE_MODE = 0;

const VIEWS = [ BankView, CodeView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the bank (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.USSD_CODE && (CodeView || (this.USSD_CODE = null))
      ) || BankView;

      VIEW && VIEW.activate(() => {
        VIEW === CodeView &&
          this.CURRENT_TIME &&
          this.$charge.poll(this.pollConfig);
      });
    });

    getChargeFee();
  };
}

// function unmount() {
//   return (dispatch) => {
//     this.$charge.cancel();
//   };
// }

function getChargeData() {
  return ({
    is_ussd: true,
    payment_type: 'USSD'
  });
}

function getViewsContext(data, store) {
  const USSD_BANKS = getValueAtPath(data, 'banks.ussd') || [];
  const REACTIVE_FIELDS = ['CURRENT_TIME', 'USSD_CODE'];
  const TIMER_DURATION = 5 * 60; // (5 minutes)

  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  $context.pollConfig = {
    onBegin() { $context.$timer.start() },
    onCancel() { $context.pollConfig.onComplete() },
    onSuccessful() { SuccessView && SuccessView.activate.call($context) },
    onComplete() { ($context.USSD_CODE = null, $context.$timer.clear() /*, self.console.log({ ...$context }) */) }
  };

  $context.$subscribe('USSD_CODE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue) {
        CodeView && CodeView.activate(() => {
          $context.$charge.poll($context.pollConfig);
        });
      }
    }, 0)
  });

  withInputFields($context, {
    bank: {
      options: USSD_BANKS,
      selector: selectBankFromList.bind($context, USSD_BANKS)
    }
  });
  
  withProperties($context, {
    TIMER_DURATION,
    INIT_VIEW: callback => {
      BankView && (
        $context.USSD_CODE = null,
        BankView.activate(callback)
      );
    }
  });

  return withCountdownTimer($context, {
    duration: TIMER_DURATION,
    onClear() { $context.$charge.cancel() },
    onTick() { $context.CURRENT_TIME = $context.$timer.current },
    onFinish() {
      $context.USSD_CODE = null;
      if ($context.$charge.cancel()) {
        // Update error to indicate USSD session timeout
        BankView && BankView.activate();
        setTimeout(() => $context.dispatch(
          ErrorState.actions.updateErrorMessage('ussd.code.expiry.error', 20)
        ), 100);
      }
    }
  });
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  // unmount,
  getChargeData,
  getViewsContext
}
